// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1m22n","text":"SelectPayment_text__2aYdq","title":"SelectPayment_title__PGuhO","btn":"SelectPayment_btn__1KCk7"};